export default "__VITE_ASSET__BtOiLKNv__"